export type LoginResult = SuccessLoginResult | FailLoginResult;

export interface SuccessLoginResult {
    isSucces: true;
}

export interface FailLoginResult {
    isSucces: false;
    code: number;
    statusText: string | null;
}

export const isSuccesLogin = (result: LoginResult): result is SuccessLoginResult => {
    return result.isSucces;
};

export const isNonSuccesLogin = (result: LoginResult): result is FailLoginResult => {
    return !result.isSucces;
};
